import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  credentialId: string;
}

export function useDeletePasskey() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ credentialId }: Params) =>
      del({ url: `/user/account/passkeys/${credentialId}` }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getCredentials });
    },
  });

  const deletePasskey = useCallback((params: Params) => mutate(params), [mutate]);

  return { deletePasskey, error, isPending, isSuccess, reset };
}
